import { Routes } from "src/routes";

export const NAME = "settings";

export const SOCIAL_SECURITY_NUMBER_HIGHLIGHT_QUERY_PARAM = "highlight";
export const SOCIAL_SECURITY_NUMBER_HIGHLIGHT_QUERY_VALUE = "socialSecurityNumber";

export const getSocialSecurityNumberHighlightPath = (): string =>
    `${Routes.settings.path}?${SOCIAL_SECURITY_NUMBER_HIGHLIGHT_QUERY_PARAM}=${SOCIAL_SECURITY_NUMBER_HIGHLIGHT_QUERY_VALUE}`;
